import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { ReactTable } from '@nhl/nhl-breakaway-ui';

import { PlayerPosition } from '~/core/enums';
import AdTag from '~/views/components/adTag/AdTag';
import { AdType } from '~/views/components/adTag/enums';

import { AdContainer, FiveGamesHeader } from '../../styles';
import { Player } from '../../types';

import { lastFiveGamesColumnsForGoalies, lastFiveGamesColumnsForSkaters } from './columns';

import { FiveGamesRow, PlayerTableContainer } from './styles';

type LastFiveGamesProps = {
    player: Player;
};
export const LastFiveGames: FC<LastFiveGamesProps> = ({ player }) => {
    const intl = useIntl();
    const isGoalie = player.position === PlayerPosition.goalie;
    return (
        <>
            <FiveGamesHeader aria-level={2}>
                <FormattedMessage description="Description for a player's last 5 games" defaultMessage="Last 5 Games" />
            </FiveGamesHeader>
            <FiveGamesRow>
                <PlayerTableContainer>
                    <ReactTable
                        data={player?.last5Games}
                        columns={isGoalie ? lastFiveGamesColumnsForGoalies(intl) : lastFiveGamesColumnsForSkaters(intl)}
                        tableId="last-five-games-table"
                    />
                </PlayerTableContainer>
                <AdContainer>
                    <AdTag divId={window.__AD_SETTINGS__.mrecDivId} adType={AdType.MEDIUM_RECTANGLE} />
                </AdContainer>
            </FiveGamesRow>
        </>
    );
};
